import React from 'react';
import { eventInfo } from '../data/mock';

const HeroSection = () => {
  return (
    <div className="relative min-h-[600px] bg-gradient-to-br from-cyan-600 via-cyan-700 to-blue-800 overflow-hidden">
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      />
      
      <div className="relative container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto">
          {/* Logos */}
          <div className="flex items-center justify-between mb-12 flex-wrap gap-8">
            {/* Wanzl Logo */}
            <div className="bg-white/95 backdrop-blur-sm px-8 py-6 rounded-xl shadow-xl">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/b/bf/Wanzl-logo.svg"
                alt="Wanzl Logo"
                className="h-12 w-auto"
              />
            </div>
            
            {/* Vše pro akci Logo */}
            <div className="bg-white/10 backdrop-blur-sm px-8 py-6 rounded-xl border border-white/20">
              <img 
                src="https://vseproakci.cz/wp-content/uploads/2024/11/VPA-logo-white.png"
                alt="Vše pro akci"
                className="h-12 w-auto"
              />
            </div>
          </div>
          
          {/* Main Title */}
          <div className="text-center text-white space-y-6">
            <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
              {eventInfo.title}
            </h1>
            <p className="text-xl md:text-2xl font-light text-cyan-100">
              Cateringová nabídka pro {eventInfo.client}
            </p>
            
            {/* Key Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 transition-all duration-300 hover:bg-white/20 hover:scale-105">
                <div className="text-cyan-200 text-3xl font-bold mb-2">
                  {eventInfo.date}
                </div>
                <div className="text-white/90 text-sm uppercase tracking-wider">
                  Termín konání
                </div>
              </div>
              
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 transition-all duration-300 hover:bg-white/20 hover:scale-105">
                <div className="text-cyan-200 text-3xl font-bold mb-2">
                  {eventInfo.time}
                </div>
                <div className="text-white/90 text-sm uppercase tracking-wider">
                  Časový rozsah
                </div>
              </div>
              
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 transition-all duration-300 hover:bg-white/20 hover:scale-105">
                <div className="text-cyan-200 text-3xl font-bold mb-2">
                  ~{eventInfo.expectedGuests}
                </div>
                <div className="text-white/90 text-sm uppercase tracking-wider">
                  Očekávaných hostů
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full">
          <path 
            fill="#f8fafc" 
            fillOpacity="1" 
            d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default HeroSection;
